import axios from '../../api/instance';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import {ADD_INSTALLATION_PLACED, CLEAR_INSTALLATION_PROGRESS_DATA} from './proposal_progress';

const namespace = 'auth/';

const SET_USERDATA = namespace + 'set_userdata';
export const CLEAR_USERDATA = namespace + 'clear_userdata';

export const LOGIN = namespace + 'login';
export const LOGOUT = namespace + 'logout';
export const REGISTER = namespace + 'register';
export const ACTIVATE = namespace + 'activate';
export const REFRESH = namespace + 'refresh';
export const REQUEST_NEW_PASSWORD = namespace + 'request_new_password';
export const SUBMIT_PASSWORD_CHANGE = namespace + 'submit_password_change';

export const UNPACKED_TOKEN = namespace + 'unpacked_token';
export const IS_AUTHENTICATED = namespace + 'is_auth';
export const GET_TOKEN = namespace + 'token';
export const GET_USERID = namespace + 'userid';

const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const INSTALLATION_PLACED_KEY = 'INSTALLATION_PLACED';

export default {
    state: {
        token: localStorage.getItem(TOKEN_KEY),
        refresh_token: localStorage.getItem(REFRESH_TOKEN_KEY),
    },
    mutations: {
        [SET_USERDATA] (state, {token, refresh_token}) {
            state.token = token;
            localStorage.setItem(TOKEN_KEY, token);
            state.refresh_token = refresh_token;
            localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
        },
        [CLEAR_USERDATA]: (state) => {
            state.token = null;
            localStorage.removeItem(TOKEN_KEY);
            state.refresh_token = null;
            localStorage.removeItem(REFRESH_TOKEN_KEY);
            localStorage.setItem(INSTALLATION_PLACED_KEY, null);
        },
    },
    actions: {
        [LOGIN]: ({commit, dispatch}, payload) => {
            payload.platform = 'client_dashboard';
            return axios.post('auth/api/accounts/authorize', payload)
                .then(authdata => {
                    commit(SET_USERDATA, authdata);
                    dispatch(ADD_INSTALLATION_PLACED, authdata.installation_placed,{root: true});
                });
        },
        [LOGOUT]: ({commit, getters}) => {
            if (!getters[IS_AUTHENTICATED]) {
                return Promise.resolve();
            }
            return axios.delete('auth/api/accounts/session')
                .finally(() => commit(CLEAR_USERDATA));
        },
        [REGISTER]: ({commit}, form) => {
            return axios.post('auth/register', form);
        },
        async [ACTIVATE] ({commit, dispatch}, payload) {
            payload.platform = 'client_dashboard';
            let authdata = await axios.post('auth/api/accounts/activate', payload);
            commit(SET_USERDATA, authdata);
            dispatch(ADD_INSTALLATION_PLACED, authdata.installation_placed,{root: true});
        },
        async [REQUEST_NEW_PASSWORD] ({commit}, payload){
            payload.platform = 'client_dashboard';
            await axios.post('auth/api/accounts/password_reset', payload);
        },
        [REFRESH]: ({commit, state}) => {
            const refresh_token = state.refresh_token;
            if (!refresh_token) return Promise.reject('no refresh_token');
            return axios.post('auth/api/accounts/refresh', {refresh_token})
                .then(authdata => {
                    commit(SET_USERDATA, authdata);
                });
        },
        async [SUBMIT_PASSWORD_CHANGE] ({commit, dispatch}, payload) {
            try {
                let authdata = await axios.put('auth/api/accounts/password', payload);
                commit(SET_USERDATA, authdata);
            } catch (e) {
                //change tekst depending on error
                throw 'Could not change password';
            }
        }
    },
    getters: {
        [UNPACKED_TOKEN]: (state) => {
            const token = state.token;
            // Does the token exist
            if (!token) return undefined;
            try {
                const token_data = jwt_decode(token);
                // Does the token unpack
                if (!token_data) return undefined;
                const issued_timestamp = moment(token_data.issuedAt);
                const expire_timestamp = issued_timestamp.clone().add(token_data.ttl, 'seconds');
                // Is the token still valid
                if (expire_timestamp.isBefore(moment())) return undefined;
                return token_data;
            } catch (error) {
                return undefined;
            }
        },
        [IS_AUTHENTICATED]: (state, getters) => !state.error && !!getters[UNPACKED_TOKEN],
        [GET_TOKEN]: (state) => state.token,
        [GET_USERID]: (state, getters) => safeGet(getters[UNPACKED_TOKEN], 'id'),
    },
};

function safeGet(obj, field) {
    return (obj) ? obj[field] : undefined;
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js